import { HttpClient } from '../../../commonApis/httpClient';
import * as ApiEvents from './apiEvents'

export const deleteEvent = (eventMessage) => ({
    eventType: ApiEvents.DELETE_NL_ENTITY,
    eventTime: Date.now(),
    eventMessage,
});



export const deleteNotesItem = (noteId) => {
    let dataSent = {
        eventType: ApiEvents.DELETE_SHIPMENT_NOTES,
        eventTime: Date.now(),
        eventMessage: 
                {
                    shipmentId: window.shipmentId,
                    noteId
                }
            
        
        };

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error from axios on FIELD delete: `, error)
        })

}

export const  deleteAIStatementAndCodeInfoHeader = (id , infoId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        aiStatementUkInfo: [
            {
                shipmentId: window.shipmentId,
                infoId: infoId
            }
          ]
       
    });
   return dataSent
}

